import {generateAction, RequestTypes} from "./Util";
import * as api from "../../services/Api";

export const GET_CALLS = new RequestTypes("GET_CALLS");

export const getCalls = () => {
  return generateAction(GET_CALLS, () =>
    api.getCalls()
  );
};